import { Component } from "@Core/component";
import $ from "jquery";
import {Html5Qrcode} from "html5-qrcode";

export class QrCodeScanner extends Component {

    async init() {
        console.log("QrCodeScanner init", this.el, this.options);

        this.scanner = null;
        this.scannerRunning = false;
        this.scanHandled = false;
        this.redirectTimer = null;
        this.resetTimer = null;

        this.translations = this.parseTranslations(this.options);

        this.$form = $("#articleByCode");
        this.$status = $("#qr-status");
        this.$scanBackground = $(".scan-background");
    }

    connected() {
        console.log("QrCodeScanner connected");

        this.el.addEventListener("click", () => {
            this.onClickQrCode();
        });
    }

    parseTranslations(options) {
        /*
         * Falls das Component-System data-options bereits als Objekt parsed.
         */
        if (
            options &&
            typeof options === "object" &&
            !Array.isArray(options)
        ) {
            return options;
        }

        /*
         * Falls data-options noch als JSON-String vorliegt.
         */
        if (typeof options === "string") {
            try {
                return JSON.parse(options);
            } catch (error) {
                console.error(
                    "QR-Scanner-Übersetzungen konnten nicht gelesen werden:",
                    error
                );
            }
        }

        return {};
    }

    translate(key, replacements = {}) {
        let text = this.translations[key];

        if (typeof text !== "string") {
            console.warn(
                `Fehlende QR-Scanner-Übersetzung: ${key}`
            );

            return key;
        }

        Object.entries(replacements).forEach(([name, value]) => {
            text = text.replaceAll(
                `{${name}}`,
                String(value)
            );
        });

        return text;
    }

    async onClickQrCode() {
        console.log("QrCodeScanner onClickQrCode");

        if (!this.scanner) {
            this.scanner = new Html5Qrcode("qr-reader");
        }

        await this.openScanner();
    }

    async openScanner() {
        if (this.scannerRunning) {
            return;
        }

        this.scanHandled = false;

        // document.body.style.overflow = "hidden";

        this.showStatus(
            this.translate("requestPermission"),
            "loading"
        );

        try {
            await this.scanner.start(
                {
                    facingMode: "environment"
                },
                {
                    fps: 10,

                    qrbox: (viewfinderWidth, viewfinderHeight) => {
                        const size = Math.floor(
                            Math.min(
                                viewfinderWidth,
                                viewfinderHeight
                            ) * 0.7
                        );

                        return {
                            width: size,
                            height: size
                        };
                    },

                    aspectRatio: 1
                },
                (decodedText, decodedResult) => {
                    this.handleSuccessScan(
                        decodedText,
                        decodedResult
                    );
                },
                () => {}
            );

            this.scannerRunning = true;
            this.$scanBackground.hide();

            this.showStatus(
                this.translate("cameraReady"),
                "default"
            );

            await this.waitForScannerVideo();
            this.scrollToScanner();
        } catch (error) {
            console.error(
                "Kamera konnte nicht gestartet werden:",
                error
            );

            this.$scanBackground.show();

            this.showStatus(
                this.getCameraErrorMessage(error),
                "error"
            );
        }
    }

    async handleSuccessScan(decodedText, decodedResult) {
        /*
         * Derselbe QR-Code wird häufig in mehreren Frames erkannt.
         */
        if (this.scanHandled) {
            return;
        }

        this.scanHandled = true;

        try {
            const scanResult = this.validateScan(decodedText);

            this.showStatus(
                this.translate("scanSuccess", {
                    code: scanResult.code
                }),
                "success"
            );

            navigator.vibrate?.(100);

            /*
             * Kamera vor der Weiterleitung sauber beenden.
             * Die Erfolgsmeldung bleibt sichtbar.
             */
            await this.closeScanner({
                hideStatus: false,
                showBackground: false
            });

            this.redirectTimer = window.setTimeout(() => {
                window.location.assign(scanResult.url);
            }, 800);
        } catch (error) {
            console.warn(
                "Ungültiger QR-Code:",
                decodedText,
                error
            );

            this.showStatus(
                error instanceof Error
                    ? error.message
                    : this.translate("invalidQrCode"),
                "error"
            );

            /*
             * Kurz die konkrete Fehlermeldung anzeigen und danach
             * erneut zum Scannen auffordern.
             */
            this.resetTimer = window.setTimeout(() => {
                this.scanHandled = false;

                this.showStatus(
                    this.translate("scanAgain"),
                    "default"
                );
            }, 1800);
        }
    }

    validateScan(scannedValue) {
        const value = String(scannedValue ?? "").trim();

        if (!value) {
            throw new Error(
                this.translate("emptyQrCode")
            );
        }

        let url;

        try {
            url = new URL(value);
        } catch {
            throw new Error(
                this.translate("invalidUrl")
            );
        }

        if (!["https:", "http:"].includes(url.protocol)) {
            throw new Error(
                this.translate("invalidProtocol")
            );
        }

        const allowedHosts = [
            "mygreiff.de",
            "www.mygreiff.de"
        ];

        const hostname = url.hostname.toLowerCase();

        if (!allowedHosts.includes(hostname)) {
            throw new Error(
                this.translate("invalidDomain")
            );
        }

        const pathParts = url.pathname
            .split("/")
            .filter(Boolean);

        const encodedCode = pathParts.at(-1);

        if (!encodedCode) {
            throw new Error(
                this.translate("missingCode")
            );
        }

        let code;

        try {
            code = decodeURIComponent(encodedCode).trim();
        } catch {
            throw new Error(
                this.translate("invalidCode")
            );
        }

        /*
         * Erlaubt Buchstaben, Zahlen, Bindestrich und Unterstrich.
         * Bei rein numerischen Codes könntest du stattdessen
         * /^\d{8}$/ verwenden.
         */
        if (!/^[a-zA-Z0-9_-]{3,100}$/.test(code)) {
            throw new Error(
                this.translate("invalidCodeFormat")
            );
        }

        return {
            code,
            url: url.href
        };
    }

    async closeScanner({
                           hideStatus = true,
                           showBackground = true
                       } = {}) {
        if (this.scannerRunning && this.scanner) {
            try {
                await this.scanner.stop();
            } catch (error) {
                console.warn(
                    "QR-Scanner konnte nicht beendet werden:",
                    error
                );
            }
        }

        this.scannerRunning = false;
        document.body.style.overflow = "";

        if (showBackground) {
            this.$scanBackground.show();
        }

        if (hideStatus) {
            this.showStatus("", "default");
        }
    }

    showStatus(message, type = "default") {
        if (!this.$status.length) {
            return;
        }

        this.$status
            .removeClass(
                "qr-status--default " +
                "qr-status--loading " +
                "qr-status--success " +
                "qr-status--error"
            )
            .addClass(`qr-status--${type}`)
            .text(message);
    }

    getCameraErrorMessage(error) {
        const name = error?.name ?? "";
        const message = String(
            error?.message ?? error ?? ""
        );

        if (
            name === "NotAllowedError" ||
            name === "PermissionDeniedError"
        ) {
            return this.translate(
                "cameraPermissionDenied"
            );
        }

        if (
            name === "NotFoundError" ||
            name === "DevicesNotFoundError"
        ) {
            return this.translate(
                "cameraNotFound"
            );
        }

        if (
            name === "NotReadableError" ||
            name === "TrackStartError"
        ) {
            return this.translate(
                "cameraNotReadable"
            );
        }

        if (
            message.includes(
                "Camera streaming not supported"
            )
        ) {
            return this.translate(
                "cameraStreamingNotSupported"
            );
        }

        return this.translate(
            "cameraStartError"
        );
    }

    async disconnected() {
        if (this.redirectTimer) {
            window.clearTimeout(this.redirectTimer);
            this.redirectTimer = null;
        }

        if (this.resetTimer) {
            window.clearTimeout(this.resetTimer);
            this.resetTimer = null;
        }

        await this.closeScanner();
    }

    async waitForScannerVideo(timeout = 2000) {
        const startTime = Date.now();

        while (Date.now() - startTime < timeout) {
            const video = document.querySelector("#qr-reader video");

            if (
                video &&
                video.readyState >= 2 &&
                video.getBoundingClientRect().height > 0
            ) {
                return video;
            }

            await new Promise(resolve => {
                window.setTimeout(resolve, 50);
            });
        }

        return null;
    }

    async scrollToScanner() {
        const video = await this.waitForScannerVideo();
        const container =
            document.querySelector(".qr-scanner") ??
            document.getElementById("qr-reader") ??
            video;

        if (!container) {
            return;
        }

        /*
         * Zwei Frames warten, damit Safari das neue Layout übernehmen kann.
         */
        await new Promise(resolve => {
            requestAnimationFrame(() => {
                requestAnimationFrame(resolve);
            });
        });

        window.setTimeout(() => {
            const rect = container.getBoundingClientRect();

            const viewport = window.visualViewport;
            const viewportHeight =
                viewport?.height ?? window.innerHeight;

            /*
             * visualViewport.offsetTop berücksichtigt die sichtbare
             * Safari-Viewport-Position.
             */
            const viewportOffsetTop =
                viewport?.offsetTop ?? 0;

            const targetY =
                window.scrollY +
                rect.top -
                viewportOffsetTop -
                Math.max(
                    16,
                    (viewportHeight - rect.height) / 2
                );

            window.scrollTo({
                top: Math.max(0, targetY),
                behavior: "smooth"
            });
        }, 200);
    }
}